<style scoped>
    .el-upload .el-upload--text{
        width: 160px;
        height: 245px;
    }
    .avatar {
      width: 160px;
      height: 225px;
    }

/*.avatar-uploader .el-upload {*/
/*    border: 1px dashed #d9d9d9;*/
/*    border-radius: 6px;*/
/*    cursor: pointer;*/
/*    position: relative;*/
/*    overflow: hidden;*/
/*}*/
/*.avatar-uploader .el-upload:hover {*/
/*    border-color: #409EFF;*/
/*}*/
/*.avatar-uploader-icon {*/
/*    font-size: 28px;*/
/*    color: #8c939d;*/
/*    width: 178px;*/
/*    height: 178px;*/
/*    text-align: center;*/
/*}*/
/*.avatar {*/
/*    width: 178px;*/
/*    height: 178px;*/
/*    display: block;*/
/*}*/
</style>
<template>

  <div :span="4">
              <h3>会员推广海报设置 <sapn style="color: #909399">(750*1150px)</sapn> </h3>
              <div style="padding:10px;">
                  <div  v-for="(item,index) in form.posterListOne" style="float:left;margin-left:10px;margin-bottom:10px;">
                        <el-upload
                                style="float:left;"
                                name="file"
                                @click.native="uploadClick(item,1)"
                                class="avatar-uploader"
                                v-model="item.posterImgUrl"
                                :action="baseUrl+'upload/uploadPic'"
                                :on-success="handleAdvertisements"
                                :data="{floder:'vipCard/poster'}"
                                :before-upload="beforeAvatarUpload"
                               :show-file-list="false">
                            <div v-if="item.posterImgUrl"  class="avatar">
                                <img  :src="item.posterImgUrl" style="width:160px;height:225px" >

                            </div>

                            <i v-else class="el-icon-plus avatar-uploader-icon" ></i>
                        <!--                    <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em>(限制大小1M以内)</div>-->

                        </el-upload>

                        <el-button size="small"  style="margin-left:10px;position:"  type="danger" @click="deletePoster(item.id,1)">删除</el-button>

                  </div>
                  <div  v-for="(item,index) in form.posterImgs" style="float:left;margin-left:10px;margin-bottom:10px;">
                      <el-upload
                              style="float:left;"
                              name="file"
                              @click.native="uploadClick(item),1"
                              class="avatar-uploader"
                              v-model="item.img"
                              :action="baseUrl+'upload/uploadPic'"
                              :on-success="handleAdvertisements"
                              :data="{floder:'vipCard/poster'}"
                              :before-upload="beforeAvatarUpload"
                             :show-file-list="false">

                          <i class="el-icon-plus avatar-uploader-icon" ></i>
      <!--                    <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em>(限制大小1M以内)</div>-->
                      </el-upload>

                  </div>

              </div>

              <div style="clear: both;"> </div>

              <div style="padding:10px;">
                  <el-divider></el-divider>
                <h3>商家推广海报设置 <sapn style="color: #909399">(750*1150px)</sapn> </h3>
                  <div  v-for="(item,index) in form.posterListTwo" style="float:left;margin-left:10px;margin-bottom:10px;">
                        <el-upload
                                style="float:left;"
                                name="file"
                                @click.native="uploadClick(item,2)"
                                class="avatar-uploader"
                                v-model="item.posterImgUrl"
                                :action="baseUrl+'upload/uploadPic'"
                                :on-success="handleAdvertisements"
                                :data="{floder:'vipCard/poster'}"
                                :before-upload="beforeAvatarUpload"
                               :show-file-list="false">
                            <div v-if="item.posterImgUrl"  class="avatar">
                                <img  :src="item.posterImgUrl" style="width:160px;height:225px" >

                            </div>

                            <i v-else class="el-icon-plus avatar-uploader-icon" ></i>
                        <!--                    <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em>(限制大小1M以内)</div>-->

                        </el-upload>
                        <el-button size="small"  style="margin-left:10px;position:"  type="danger" @click="deletePoster(item.id,1)">删除</el-button>

                  </div>
                  <div  v-for="(item,index) in form.posterImgs" style="float:left;margin-left:10px;margin-bottom:10px;">
                      <el-upload
                              style="float:left;"
                              name="file"
                              @click.native="uploadClick(item,2)"
                              class="avatar-uploader"
                              v-model="item.img"
                              :action="baseUrl+'upload/uploadPic'"
                              :on-success="handleAdvertisements"
                              :data="{floder:'vipCard/poster'}"
                              :before-upload="beforeAvatarUpload"
                             :show-file-list="false">

                          <i  class="el-icon-plus avatar-uploader-icon" ></i>
      <!--                    <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em>(限制大小1M以内)</div>-->
                      </el-upload>

                  </div>

              </div>
      </div>

</template>
<script>
import TableTemplate from '@/components/TableTemplate'
import distributorPosterModel from '@/framework/models/distributorPosterModel'
import BasicPager from '@/mixins/BasicPager'
import Config from '@/framework/configs/Config'
export default {
  name: 'distributor-poster',
  extends: BasicPager,
  components: { TableTemplate },
  data () {
    return {
      baseUrl: Config.baseUrl,
      imageUrl: Config.imageUrl,
      item: null,
      form: {
        type: 1,
        posterImgs: [{ img: '' }],
        distributoerImgsList: [],
        posterListOne: [],
        posterListTwo: []
      }
    }
  },
  created: function () {
    this.findPosterList()
  },
  methods: {
    beforeAvatarUpload (file) {
      const isLt1M = file.size / 1024 / 1024 < 1
      if (!isLt1M) {
        this.$message.error('上传图片大小不能超过 1MB!')
      }
      return isLt1M
    },
    uploadClick (data, type) {
      this.form.type = type
      this.selectItem = data
    },
    findPosterList () {
      let _this = this
      let params = {}

      let userInfo = JSON.parse(localStorage.userInfo)
      if (userInfo) {
        params.channelId = userInfo.id
      }
      let listener = {
        success (dataInfo) {
          _this.form.posterListTwo = dataInfo.datas.posterListTwo
          _this.form.posterListOne = dataInfo.datas.posterListOne
        }
      }
      distributorPosterModel.findPosterList(this, params, listener)
    },
    handleAdvertisements (e) {
      let params = { 'posterImgUrl': e.datas[0] }
      if (this.selectItem && this.selectItem.id) {
        params.posterId = this.selectItem.id
      }

      params.type = this.form.type
      this.selectItem.img = this.imageUrl + e.datas[0]

      let _this = this

      let userInfo = JSON.parse(localStorage.userInfo)
      if (userInfo) {
        params.id = userInfo.id
      }
      let listener = {
        success (dataInfo) {
          if (dataInfo.success) {
            _this.$message.success('上传海报图成功!')
            _this.form.posterImgs = [{ img: '' }]
            _this.findPosterList()
          } else {
            this.$message.error('上传海报图失败!')
          }
        }
      }
      distributorPosterModel.savePoster(this, params, listener)
    },

    deletePoster (id, type) {
      // 删除验证
      let count = 0
      if (type == 1) {
        count = this.form.posterListOne
      } else {
        count = this.form.posterListTwo
      }

      if (count <= 1) {
        this.$message.error('至少要 保留一个海报图，所以不能够继续删除!')
        return
      }

      let _this = this
      let params = { 'id': id }
      let listener = {
        success (dataInfo) {
          if (dataInfo.success) {
            _this.$message.success('删除海报图成功!')
            _this.findPosterList()
          } else {
            this.$message.error('删除海报图失败!')
          }
        }
      }
      distributorPosterModel.deletePoster(this, params, listener)
    }
  }
}
</script>
